import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { PhotosTab } from "./photos-tab";

export const UnsplashTab: FC<{
  onImageClick?: (imageUrl: string) => void;
  selectedImage: string | null;
  onSelectionChange?: (hasSelection: boolean) => void;
  hidden?: boolean;
}> = (props) => {
  const { t } = useTranslation();

  return <PhotosTab endpoint="/photos/stock" placeholder={t("Search Unsplash")} {...props} />;
};
